// Import/Export Component

import api from '../api.js';
import { loadBookmarks } from './BookmarkList.js';

export function renderImportExport() {
  return `
    <div class="modal" id="import-export-modal">
      <div class="modal-content">
        <div class="modal-header">
          <h2>Import & Export</h2>
          <button class="modal-close" id="close-import-export-modal">&times;</button>
        </div>

        <div class="import-export-container">
          <div class="import-section">
            <h3>Lesezeichen importieren</h3>
            <p class="text-muted">Importiere Lesezeichen aus HTML (Browser-Export) oder JSON Format.</p>

            <form id="import-form" class="form">
              <div class="form-group">
                <label for="import-file">Datei auswählen</label>
                <input type="file" id="import-file" accept=".html,.json" required>
              </div>

              <div class="form-group">
                <label for="import-format">Format</label>
                <select id="import-format" name="format">
                  <option value="html">HTML (Browser Bookmarks)</option>
                  <option value="json">JSON</option>
                </select>
              </div>

              <button type="submit" class="btn btn-primary">Importieren</button>
            </form>

            <div id="import-result" class="import-result"></div>
          </div>

          <div class="export-section">
            <h3>Lesezeichen exportieren</h3>
            <p class="text-muted">Exportiere alle deine Lesezeichen für Backup oder Migration.</p>

            <div class="export-buttons">
              <button id="export-html" class="btn btn-primary">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
                Als HTML exportieren
              </button>

              <button id="export-json" class="btn btn-primary">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
                Als JSON exportieren
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
}

export function initImportExport() {
  const form = document.getElementById('import-form');
  const exportHtmlBtn = document.getElementById('export-html');
  const exportJsonBtn = document.getElementById('export-json');

  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    await importBookmarks();
  });

  exportHtmlBtn?.addEventListener('click', () => exportBookmarks('html'));
  exportJsonBtn?.addEventListener('click', () => exportBookmarks('json'));

  document.getElementById('close-import-export-modal')?.addEventListener('click', closeImportExport);

  document.getElementById('import-export-modal')?.addEventListener('click', (e) => {
    if (e.target.id === 'import-export-modal') {
      closeImportExport();
    }
  });
}

async function importBookmarks() {
  const fileInput = document.getElementById('import-file');
  const formatSelect = document.getElementById('import-format');
  const resultDiv = document.getElementById('import-result');

  if (!fileInput.files || fileInput.files.length === 0) {
    showError('Bitte wähle eine Datei aus.');
    return;
  }

  const file = fileInput.files[0];
  const format = formatSelect.value;

  resultDiv.innerHTML = '<p class="loading">Importiere...</p>';

  try {
    const result = await api.importBookmarks(file, format);

    const summary = `
      <div class="import-summary success">
        <h4>Import erfolgreich!</h4>
        <ul>
          <li>${result.imported || 0} Lesezeichen importiert</li>
          ${result.skipped ? `<li>${result.skipped} Duplikate übersprungen</li>` : ''}
          ${result.errors ? `<li>${result.errors} Fehler</li>` : ''}
        </ul>
      </div>
    `;

    resultDiv.innerHTML = summary;
    showSuccess(`${result.imported || 0} Lesezeichen erfolgreich importiert`);

    // Reload bookmarks
    setTimeout(async () => {
      await loadBookmarks();
    }, 1500);
  } catch (error) {
    console.error('Import failed:', error);
    resultDiv.innerHTML = `<div class="import-summary error">Import fehlgeschlagen: ${error.message}</div>`;
    showError('Import fehlgeschlagen: ' + error.message);
  }
}

async function exportBookmarks(format) {
  try {
    await api.exportBookmarks(format);
    showSuccess(`Export als ${format.toUpperCase()} gestartet`);
  } catch (error) {
    console.error('Export failed:', error);
    showError('Export fehlgeschlagen: ' + error.message);
  }
}

function closeImportExport() {
  const modal = document.getElementById('import-export-modal');
  if (modal) {
    modal.remove();
  }
}

function showError(message) {
  const event = new CustomEvent('show-notification', {
    detail: { type: 'error', message }
  });
  document.dispatchEvent(event);
}

function showSuccess(message) {
  const event = new CustomEvent('show-notification', {
    detail: { type: 'success', message }
  });
  document.dispatchEvent(event);
}
